import React from 'react';

const Input = React.forwardRef(({ className = '', ...props }, ref) => {
    return (
        <input
            className={`flex h-11 w-full rounded-lg bg-input-bg py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sm-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-0 ${className}`}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = 'Input';

const Textarea = React.forwardRef(({ className = '', ...props }, ref) => {
    return (
        <textarea
            className={`flex min-h-[80px] w-full rounded-lg bg-input-bg px-3 py-2 text-sm ring-offset-background placeholder:text-text-gray focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sm-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border-0 ${className}`}
            ref={ref}
            {...props}
        />
    );
});
Textarea.displayName = 'Textarea';

const Label = ({ children, className = '', ...props }) => {
    return (
        <label
            className={`text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-primary-text ${className}`}
            {...props}
        >
            {children}
        </label>
    );
};

export { Input, Textarea, Label };
